export const tableSettings = (props, mergeWith = {}) => {
  return {
    colHeaders: props.colHeaders,
    nestedHeaders: props.nestedHeaders,
    cells: props.cells,
    columnSorting: props.columnSorting,
    hiddenColumns: props.hiddenColumns,
    colWidths: props.colWidths,
    rowHeights: props.rowHeights || 43,
    comments: false, // prevent editing of comments
    contextMenu: ["copy"],
    data: props.data,
    disableVisualSelection: true, // prevent user from visually selecting
    dropdownMenu: props.dropdownMenu,
    filters: props.filters,
    fixedRowsBottom: props.fixedRowsBottom,
    fragmentSelection: props.fragmentSelection,
    headerInfo: props.headerInfo,
    height: props.height,
    licenseKey: "a9c5a-b0da7-0c4a0-54628-a7f11",
    manualColumnResize: props.manualColumnResize || false, // prevent dragging to resize columns
    manualRowResize: false, // prevent dragging to resize rows
    nestedRows: props.nestedRows,
    readOnly: true, // make table cells read-only
    rowHeaders: props.rowHeaders || false,
    rowHeaderWidth: props.rowHeaderWidth || false,
    sortIndicator: true,
    stretchH: props.stretchH,
    renderAllRows: props.renderAllRows || false,
    width: props.width,
    wordWrap: props.wordWrap,
    calculateTotals: props.calculateTotals || false,
    ...mergeWith
  };
};
